const BgUi = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      <div
        className="absolute -left-[8rem] top-0 w-[100px] h-[520px]"
        style={{
          background:
            'linear-gradient(to right, #0D0D0D 0%, transparent 85%, #FA5629 65%, #0D0D0D 100%)',
          transform: 'rotate(40deg)',
          filter: 'blur(27px)',
        }}
      />

      <div
        className="absolute left-16 top-10 w-[100px] h-[480px]"
        style={{
          background:
            'linear-gradient(to right, #0D0D0D 0%, transparent 90%, #FA5629 60%, #0D0D0D 100%)',
          transform: 'rotate(40deg)',
          filter: 'blur(27px)',
        }}
      />

      <div
        className="absolute right-24 top-20 w-[50px] h-[480px]"
        style={{
          background:
            'linear-gradient(to right, #0D0D0D 0%, transparent 90%, #FA5629 60%, #0D0D0D 100%)',
          transform: 'rotate(40deg)',
          filter: 'blur(27px)',
        }}
      />
    </div>
  );
};

export default BgUi;
